import EmergencyBanner from "../components/site/EmergencyBanner";
import Header from "../components/site/Header";
import Hero from "../components/site/Hero";
import TrustBar from "../components/site/TrustBar";
import Services from "../components/site/Services";
import WhyUs from "../components/site/WhyUs";
import Booking from "../components/site/Booking";
import Testimonials from "../components/site/Testimonials";
import ServiceArea from "../components/site/ServiceArea";
import Footer from "../components/site/Footer";

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white text-slate-900" data-testid="home-page">
      <EmergencyBanner />
      <Header />
      <main>
        <Hero />
        <TrustBar />
        <Services />
        <WhyUs />
        <Booking />
        <Testimonials />
        <ServiceArea />
      </main>
      <Footer />
    </div>
  );
}
